ready(function(){

		// -- blockImagesSlider glide --
		const blockImagesSliderEl = document.querySelectorAll('.glide--blockImagesSlider');
		if (blockImagesSliderEl) {
			const options = { 
			};
			Object.values(blockImagesSliderEl).map((slide) => {
				new Glide(slide, options).mount();
			});
		}


		// -- artworksMap glide --
		const artworksMapEl = document.querySelector('.glide--exhibitionsMap');
		if (artworksMapEl) {

			// -- init --
			const artworksMapGlideOptions = {
			};
			const artworksMapGlide = new Glide('.glide--exhibitionsMap', artworksMapGlideOptions);
			artworksMapGlide.on(['run'], function(e) {
				const currentIndex = artworksMapGlide.index;
		    const slide = document.querySelector(`.glide__slide[data-index="${currentIndex}"]`);
		    highlightFeature(JSON.parse(slide.dataset.coords));
			});
			
			// -- enable/disable artworksMap glide --
			const bodyStyles = window.getComputedStyle(document.body);
			const smMin = bodyStyles.getPropertyValue('--sm-min');
			function debounce(func, wait) {
			  let timeout;
			  return function () {
			    const context = this;
			    const args = arguments;
			    clearTimeout(timeout);
			    timeout = setTimeout(() => {
			      func.apply(context, args);
			    }, wait);
			  };
			}
			function glideStatus() {
			  var windowSize = window.innerWidth;
			  if (windowSize > parseInt(smMin)) {
			    artworksMapGlide.destroy();
			  } else {
			    artworksMapGlide.mount();
			  }
			}
			const debouncedGlideStatus = debounce(glideStatus, 200);
			glideStatus();
			window.addEventListener('resize', debouncedGlideStatus);
		}

});